import { HeartAnimationElement } from "./classes/HeartAnimationElement";
export const customHeartAnimationName = "wv-heart-animation";

export function registerHeartAnimationElement() {
  if (!customElements.get(customHeartAnimationName)) {
    window.customElements.define(customHeartAnimationName, HeartAnimationElement);
  }
}
